import { useMemo, useEffect } from 'react';

import { debounce } from '@perpay-web/utils/debounce';

/**
 * Wraps a data module with debounced dataRequest functionality
 * @param {Object} dataModule - The data module to wrap
 * @param {number} debounceMs - Debounce delay in milliseconds
 * @returns {Object} Data module with debounced dataRequest
 */
export const useDebouncedDataModule = (dataModule, debounceMs = 300) => {
    const debouncedDataRequest = useMemo(
        () => debounce((value) => dataModule.dataRequest(value), debounceMs),
        [dataModule, debounceMs],
    );

    useEffect(
        () => () => {
            debouncedDataRequest.cancel();
        },
        [debouncedDataRequest],
    );

    return {
        ...dataModule,
        dataRequest: debouncedDataRequest,
    };
};
